import { NgModule } from '@angular/core';
import { RestrictedCountriesComponent } from './restricted-countries/restricted-countries.component';
import { RestrictedCountriesPageModule } from '@shared/landings/restricted-countries-page/restricted-countries-page.module';
import { RestrictedCountriesRoutingModule } from './restricted-countries-routing.module';
import { TemplateModule } from '@project/shared/template/template.module';



@NgModule({
  declarations: [
    RestrictedCountriesComponent
  ],
  imports: [
    TemplateModule,
    RestrictedCountriesPageModule,
    RestrictedCountriesRoutingModule,
  ]
})
export class RestrictedCountriesModule { }
